import useProfileSecurity from 'components/Profile/hooks/useProfileSecurity';
import Text from 'core/utils/Text';
import { FC } from 'react';
import DgButton from 'styles/UI/Button/DgButton';
import DgModal from 'styles/UI/Modal/DgModal';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePassword: FC = () => {
	const {
		hideUserPasswordModal,
		modalUserPassword,
		showUserPasswordModal,
		onFinishTransactionPassword,
		transactionPasswordForm,
		transactionPasswordIsLoading,
		onFinishUserPassword,
		userPasswordForm,
		userPasswordIsLoading,
	} = useProfileSecurity();

	return (
		<>
			<DgModal
				title='login-password'
				open={modalUserPassword}
				onCancel={hideUserPasswordModal}
			>
				<ChangePasswordForm
					onFinishTransactionPassword={onFinishTransactionPassword}
					transactionPasswordForm={transactionPasswordForm}
					transactionPasswordIsLoading={transactionPasswordIsLoading}
					onFinishUserPassword={onFinishUserPassword}
					userPasswordForm={userPasswordForm}
					userPasswordIsLoading={userPasswordIsLoading}
					isUserPassword={true}
				/>
			</DgModal>
			<div className='border-b border-b-[var(--dg-border-color)] pb-3'>
				<div className='flex justify-between items-center flex-wrap'>
					<Text tid='login-password' />

					<DgButton title='set-login-password' onClick={showUserPasswordModal} />
				</div>
			</div>
		</>
	);
};

export default ChangePassword;
